import { useEffect, useRef } from 'react';

type Options = {
  maxHeight?: number;
  open?: boolean;
};

export const useAutosizeTextArea = (value: string, options: Options = {}) => {
  const ref = useRef<HTMLTextAreaElement | null>(null);

  const { maxHeight, open } = options;

  useEffect(() => {
    const el = ref.current;
    if (el) {
      el.style.height = 'auto';

      if (maxHeight) {
        const nextHeight = Math.min(el.scrollHeight, maxHeight);
        el.style.height = `${nextHeight}px`;
        el.style.overflowY = el.scrollHeight > maxHeight ? 'auto' : 'hidden';
      } else {
        el.style.height = `${el.scrollHeight}px`;
      }
    }
  }, [value, open, maxHeight]);

  return ref;
};
